import { theme as antdTheme, type ThemeConfig } from "antd";

/** Dark industrial console — warm ink surfaces, single amber accent, IBM Plex. */
export const dashboardTheme: ThemeConfig = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    // No enter/leave animations: instant, instrument-panel feel — and immune
    // to environments that throttle rAF (hidden tabs, webviews), where
    // rc-motion would otherwise freeze drawers/modals at their start frame.
    motion: false,
    colorPrimary: "#f2a51a",
    colorInfo: "#6db3e8",
    colorSuccess: "#8fc97a",
    colorError: "#e06456",
    colorWarning: "#f2a51a",
    colorBgBase: "#121410",
    colorBgContainer: "#1a1d18",
    colorBgElevated: "#20241e",
    colorBorder: "#2c322a",
    colorBorderSecondary: "#232820",
    colorText: "#e9e7dc",
    colorTextSecondary: "#98a090",
    colorTextTertiary: "#6b7264",
    borderRadius: 4,
    fontFamily: "'IBM Plex Sans', system-ui, sans-serif",
    fontSize: 13,
    controlHeight: 30,
  },
  components: {
    Table: {
      headerBg: "#1a1d18",
      rowHoverBg: "#20241e",
      cellPaddingBlock: 9,
    },
    Drawer: {
      colorBgElevated: "#181b16",
    },
    Modal: {
      contentBg: "#1a1d18",
      headerBg: "#1a1d18",
    },
  },
};
